export const BlockTagsWithAnyContent = ['aside', 'article', 'div', 'section', 'main', 'nav'];
export const BlockTagsWithPhrasingContent = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'pre'];
export const InlineTagsWithPhrasingContent = ['span', 'strong', 'em', 'b', 'i', 'u', 's', 'strike', 'big', 'small', 'sub', 'sup', 'center', 'cite', 'tt', 'code', 'kbd', 'samp', 'var'];
export const ListTags = ['ul', 'ol'];
